import api from './api';

export const paymentApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getClientToken: builder.query({
      query: ({ restaurantId, isDelivery }) => `payment/getClientToken/${restaurantId}/${isDelivery}`,
    }),
    pay: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: 'payment/pay',
        body
      }),
    }),
  }),
  overrideExisting: false,
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLazyGetClientTokenQuery,
  usePayMutation,
} = paymentApi;